import { render, staticRenderFns } from "./ThePagebar.vue?vue&type=template&id=4910430d&scoped=true&lang=html&"
import script from "./ThePagebar.vue?vue&type=script&lang=js&"
export * from "./ThePagebar.vue?vue&type=script&lang=js&"
import style0 from "./ThePagebar.vue?vue&type=style&index=0&id=4910430d&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910430d",
  null
  
)

export default component.exports